import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Flex, SvgIcon, Text } from 'Components/Base';

const InformationCardWrapper = styled(Flex)`
  background: ${({ theme }) => theme.colors.bsGrays.gray50};
  grid-row-gap: 8px;
  min-width: 120px;
  padding: 12px 24px;
  border-radius: 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex: 1;
`;

const InformationCard = (props) => {
  const { icon, count, unit, ...restProps } = props;
  return (
    <InformationCardWrapper {...restProps}>
      <SvgIcon icon={icon} size={24} width={24} height={24} color={'clear.clearGrayDark'} />
      <Flex gridColumnGap={1}>
        <Text color={'clear.clearGrayDark'} textStyle={'body2'} fontWeight={700}>
          {count}
        </Text>
        <Text color={'clear.clearGrayDark'} textStyle={'body2'} fontWeight={700}>
          {unit}
        </Text>
      </Flex>
    </InformationCardWrapper>
  );
};

InformationCard.propTypes = {
  icon: PropTypes.func,
  count: PropTypes.number,
  unit: PropTypes.string,
};

export default InformationCard;
